'use client'

export { CoachMapBlockClient as CoachMapBlock } from './Component.client'
